import { useQuery } from '@tanstack/react-query';
import { container } from '../../../../shared/di/container.js';
import type { MediaFolderArgs } from '../../data/datasources/SupabaseUploadRemoteDataSource.js';

/**
 * Resolve the canonical media folder server-side. `enabled` gates the query so
 * callers can wait until required ids (e.g. a picked location) are present.
 */
export function useMediaFolder(args: MediaFolderArgs, enabled = true) {
  return useQuery({
    queryKey: [
      'media_folder',
      args.mode,
      args.sessionId ?? null,
      args.fieldId ?? null,
      args.locationId ?? null,
      args.projectId ?? null,
      args.orgId ?? null,
    ],
    queryFn: () => container.upload.getMediaFolderUseCase(args),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
